import store from "../../../../../store/store";

export const componentKey = 'MASTER_TEST_UNIT';

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setMasterTestUnitList: (state, action) => {
            state.masterTestUnitData = action.payload;
        }, 
        setOpenAddTestUnitModal: (state, action) => {
            state.isOpenAddTestUnitModal = action.payload;
        }
    },
    initialReducerState: {
        masterTestUnitData: [],
        isOpenAddTestUnitModal: false,
    },
});

export const { setMasterTestUnitList, setOpenAddTestUnitModal } = actions; 